import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const KompletteraAnlaggningsId = lazy(() => import("@/pages/KompletteraAnlaggningsId"));

export const Route = createFileRoute("/komplettera-anlaggningsid")({
  ssr: false,
  validateSearch: (search: Record<string, unknown>) => ({
    order: typeof search["order"] === "string" ? search["order"] : "",
    t: typeof search["t"] === "string" ? search["t"] : "",
  }),
  head: () => ({
    meta: [
      { title: "Komplettera anläggnings-ID | Elmarknad.se" },
      {
        name: "description",
        content: "Komplettera ditt anläggnings-ID manuellt eller hämta det med BankID.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { property: "og:title", content: "Komplettera anläggnings-ID | Elmarknad.se" },
      {
        property: "og:description",
        content: "Komplettera ditt anläggnings-ID manuellt eller hämta det med BankID.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <KompletteraAnlaggningsId />,
});
